<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text large" [innerHTML]="textCopy.contraventionsTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.contraventionsSubtitle"></div>
    <contraventions-question [valuesSelected]="contraventions.valuesSelected"
                             [options]="contraventions.options"
                         (selectAnswer)="onContraventionsSelected($event)"
                         [active]="contraventions.active"></contraventions-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
